import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "notify-content-wrap"
};
var _hoisted_2 = {
  class: "notify-content-text"
};
import SvgIcon from "./SvgIcon.vue";
import { computed } from "vue";
export default {
  __name: 'NotifyContent',
  props: {
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "fail" // 枚举：warn、fail、success
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var SvgIconName = computed(function () {
      return {
        warn: "notify_warn",
        fail: "notify_fail",
        success: "notify_success"
      }[props.type];
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass("notify-content notify-content-".concat(__props.type))
      }, [SvgIconName.value ? (_openBlock(), _createBlock(SvgIcon, {
        key: 0,
        class: "notify-content-icon",
        name: SvgIconName.value,
        size: "24"
      }, null, 8, ["name"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, _toDisplayString(__props.message), 1)], 2)]);
    };
  }
};